import { Box, FormGroup, Typography } from "@mui/material";
import { DateRangeFilter } from "../../../../../components/dataGridFilter/filter-components/DateRangeFilter";
import { IntegerRangeFilter } from "../../../../../components/dataGridFilter/filter-components/IntegerRangeFilter";
import { TextFilter } from "../../../../../components/dataGridFilter/filter-components/TextFilter";
import { orderStatusOptions } from "./utils/options";
import FlagIcon from "@mui/icons-material/Flag";
import { DropdownFilter } from "../../../../../components/dataGridFilter/filter-components/DropdownFilter";
import { SwitchFilter } from "../../../../../components/dataGridFilter/filter-components/SwitchFilter";
import { useAllFlags } from "../../../../../components/flag/utils/useAllFlags";

export const FilterGroup1 = () => {
  const baseKey = "pages.orders.list.filters";
  const { flags } = useAllFlags();
  const formattedFlags = flags?.data?.map((flag) => ({
    value: String(flag.id),
    label: flag.flagName,
    labelkey: flag.flagColor,
  }));

  return (
    <FormGroup
      sx={{
        bgcolor: "customBackground.box",
        borderRadius: 1,
        mb: 2,
        padding: 2,
        display: "flex",
        gap: 2,
      }}
    >
      <DateRangeFilter
        name="deliveryOrder.amazonOrder.purchaseDate"
        labelKey={`${baseKey}.purchaseDate`}
      />
      <IntegerRangeFilter
        name={"productQuantity"}
        labelKey={`${baseKey}.productQuantity`}
      />
      <IntegerRangeFilter
        name={"deliveryOrder.amazonOrder.orderTotalAmount"}
        labelKey={`${baseKey}.orderTotalAmount`}
      />
      <DropdownFilter
        name="orderStatus"
        labelKey={`${baseKey}.orderStatus`}
        options={orderStatusOptions("pages.orders.detail.status")}
      />

      <DropdownFilter
        name={"userFlag"}
        labelKey={`${baseKey}.userFlag`}
        options={formattedFlags ?? []}
        renderOption={(option) => (
          <Box display="flex" alignItems="center" gap={1}>
            <FlagIcon sx={{ color: option.labelkey ?? "inherit" }} />

            <Typography>{option.label}</Typography>
          </Box>
        )}
      />

      <SwitchFilter
        name="deliveryOrder.shipment.trackingNumber"
        labelKey={`${baseKey}.preconfirm`}
        customValue={""}
      />
      <TextFilter
        name="deliveryOrder.shipment.trackingNumber"
        labelKey={`${baseKey}.trackingNumber`}
        operator="eq"
      />
      <TextFilter
        name="deliveryOrder.buyerInfo.buyerName"
        labelKey={`${baseKey}.buyerName`}
      />
      <TextFilter
        name="supplierEmail"
        labelKey={`${baseKey}.buyerEmail`}
        operator="eq"
      />
      <TextFilter
        name="asin"
        labelKey={`${baseKey}.asin`}
        operator="eq"
        convertTo="lowercase"
      />
    </FormGroup>
  );
};
